import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";


const CredencialSites = () => {
    const navigate = useNavigate();
    //var tokenLogin="25824F3E492DFB58EADD24A68B611113E784992014A014307511DF247C0C137C";
    const tokenLogin= localStorage.getItem("hashLogin")
    var credencialURL="https://mimuni.app/home?UID="+tokenLogin
    return (
        
       <div class="container text-center mainContent" >
         {process.env.NODE_ENV}
        <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/")}}/>

     <iframe src={credencialURL} frameborder="0" width="100%" height="70%"></iframe>
       </div>
    );
    }
export default CredencialSites;